// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@conklin/XDL/Utilities";
import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 12,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "secondary",
    css: css`
        padding: 0 27px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        padding-top: 14px;
        gap: 10px;

        ${xScreen("lt", "xs")} {
            padding-top: 10px;
            flex-direction: column;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h3",
    as: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        font-size: 14px;
        line-height: 22px;
        ul {
            margin: 16px 0 0 8px;
            li::marker {
                color: ${color("primary")};
            }
        }
    `,
};
